import {
  CLEAR_FETCH_TESTIMONIAL_AD_STATES,
  FETCH_TESTIMONIAL_AD_FAILURE,
  FETCH_TESTIMONIAL_AD_SUCCESS,
  REQUEST_TESTIMONIAL_FETCH_AD,
} from "./testimonial.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const fetchTestimonialAdReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TESTIMONIAL_FETCH_AD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TESTIMONIAL_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };
    case FETCH_TESTIMONIAL_AD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };
    case CLEAR_FETCH_TESTIMONIAL_AD_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };
    default:
      return state;
  }
};
export default fetchTestimonialAdReducer;
